import { ReactElement } from 'react'
import { IconProps } from '../icons'

const OutlinedError = ({
  height = '30',
  width = '30',
  hardcodedColor = '#F5841B',
  color,
  ...props
}: IconProps): ReactElement => {
  const colorClass = color ? `${`fill-${color}`}` : ''
  const fill = hardcodedColor && !color ? hardcodedColor : 'currentColor'

  return (
    <svg
      width={width}
      height={height}
      className={colorClass}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Group">
        <path
          id="Vector"
          d="M13.9583 17.7471C14.2741 17.6523 14.6214 17.6207 15.0005 17.6207C15.3794 17.6207 15.7268 17.6839 16.0742 17.7786L17.211 8.62074V8.3365C17.211 7.13645 16.2321 6.12598 15.0005 6.12598C14.3689 6.12598 13.7689 6.41021 13.3584 6.85235C12.9478 7.32603 12.7268 7.95761 12.7899 8.58919L13.9583 17.7471Z"
          fill={fill}
        />
        <path
          id="Vector_2"
          d="M14.9996 19.4209C13.768 19.4209 12.7891 20.3998 12.7891 21.6314C12.7891 22.863 13.768 23.8735 14.9996 23.8735C16.2312 23.8735 17.2417 22.863 17.2417 21.6314C17.2101 20.4314 16.2312 19.4209 14.9996 19.4209Z"
          fill={fill}
        />
        <path
          id="Vector_3"
          d="M15 0C6.72632 0 0 6.72632 0 15C0 23.2737 6.72632 30 15 30C23.2737 30 30 23.2737 30 15C30 6.72632 23.2737 0 15 0ZM15 27.3789C8.17895 27.3789 2.62105 21.8211 2.62105 15C2.62105 8.17895 8.17895 2.62105 15 2.62105C21.8211 2.62105 27.3789 8.17895 27.3789 15C27.3789 21.8211 21.8211 27.3789 15 27.3789Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default OutlinedError
